var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "step2" },
    [
      _c(
        "b-form",
        [
          !_vm.appid || _vm.appid.length === 0
            ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                _c("h4", { staticClass: "alert-heading" }, [
                  _vm._v("Facebook App ID is not set"),
                ]),
                _c(
                  "div",
                  { staticClass: "alert-body" },
                  [
                    _c("span", [
                      _vm._v("Please set the Facebook App ID in the"),
                    ]),
                    _c(
                      "b-link",
                      {
                        staticClass: "mx-1",
                        attrs: { to: "/account-setting" },
                      },
                      [_vm._v("Marketing Settings")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("b-row", { staticClass: "mb-2 justify-content-end" }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              model: {
                                value: _vm.facebookChecked,
                                callback: function ($$v) {
                                  _vm.facebookChecked = $$v
                                },
                                expression: "facebookChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("Facebook"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("feather-icon", {
                              staticClass: "text-info",
                              attrs: { icon: "FacebookIcon", size: "25" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              model: {
                                value: _vm.instagramChecked,
                                callback: function ($$v) {
                                  _vm.instagramChecked = $$v
                                },
                                expression: "instagramChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("Instagram"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("feather-icon", {
                              staticClass: "text-danger",
                              attrs: { icon: "InstagramIcon", size: "25" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              model: {
                                value: _vm.linkedinChecked,
                                callback: function ($$v) {
                                  _vm.linkedinChecked = $$v
                                },
                                expression: "linkedinChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("LinkedIn"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("feather-icon", {
                              staticClass: "text-info text-darken-2",
                              attrs: { icon: "LinkedinIcon", size: "25" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              model: {
                                value: _vm.EventChecked,
                                callback: function ($$v) {
                                  _vm.EventChecked = $$v
                                },
                                expression: "EventChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("Event"),
                            ]),
                          ],
                          1
                        ),
                        _c("div"),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-tabs",
                    [
                      _vm.facebookChecked
                        ? _c(
                            "b-tab",
                            { attrs: { title: "Facebook" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Facebook Post",
                                    "label-for": "description",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Facebook Post",
                                      vid: "Description",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("quill-editor", {
                                                attrs: {
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.campaignId.description,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.campaignId,
                                                      "description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "campaignId.description",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1354877886
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                [
                                  _vm.facebookChecked
                                    ? _c(
                                        "b-form-group",
                                        { staticClass: "mb-1" },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              rules: "required",
                                              name: "date and time",
                                              vid: "scheduledPublishedDate",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-end mb-1",
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            staticClass:
                                                              "text-info",
                                                            attrs: {
                                                              icon: "FacebookIcon",
                                                              size: "18",
                                                            },
                                                          }),
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "ml-1 mb-0",
                                                            },
                                                            [_vm._v("Facebook")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("b-form-datepicker", {
                                                        attrs: {
                                                          id: "form-control",
                                                          placeholder:
                                                            "Choose a date",
                                                          local: "en",
                                                          "initial-date":
                                                            new Date(),
                                                          min: _vm.today,
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.campaignId
                                                              .scheduledPublishedDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.campaignId,
                                                              "scheduledPublishedDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "campaignId.scheduledPublishedDate",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1685503220
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.instagramChecked
                        ? _c(
                            "b-tab",
                            { attrs: { title: "Instagram" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Instagram Post",
                                    "label-for": "description",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Instagram Post",
                                      vid: "Description",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("quill-editor", {
                                                attrs: {
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.campaignId.description,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.campaignId,
                                                      "description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "campaignId.description",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1354877886
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.linkedinChecked
                        ? _c(
                            "b-tab",
                            { attrs: { title: "LinkedIn" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "LinkedIn Post",
                                    "label-for": "description",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "LinkedIn Post",
                                      vid: "Description",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("quill-editor", {
                                                attrs: {
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.campaignId.description,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.campaignId,
                                                      "description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "campaignId.description",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1354877886
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.EventChecked
                        ? _c(
                            "b-tab",
                            { attrs: { title: "Events" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start my-1",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "primary" },
                                          on: { click: _vm.showModal },
                                        },
                                        [_vm._v("Add Task")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("b-table", {
                                attrs: {
                                  items: _vm.eventsTaskslist,
                                  fields: _vm.tasks_fields,
                                  striped: "",
                                  responsive: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(assignee)",
                                      fn: function (data) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getAssigneeName(
                                                    data.item.assignee
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(startDate)",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  data.item.startDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(endDate)",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  data.item.endDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(status)",
                                      fn: function (row) {
                                        return [
                                          !row.item.editingStatus
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editField(
                                                        row.item,
                                                        "editingStatus"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-badge",
                                                    {
                                                      attrs: {
                                                        variant:
                                                          _vm.getStatusColor(
                                                            row.item.status
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(row.item.status)
                                                      ),
                                                    ]
                                                  ),
                                                  _c("feather-icon", {
                                                    staticClass: "ml-2",
                                                    attrs: { icon: "EditIcon" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("b-form-select", {
                                                    attrs: {
                                                      options:
                                                        _vm.statusOptions,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.saveField(
                                                          row.item,
                                                          "editingStatus"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: row.item.status,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          row.item,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.item.status",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3796907774
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.facebookChecked &&
                  !_vm.instagramChecked &&
                  _vm.linkedinChecked == false &&
                  !_vm.EventChecked
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Description",
                            "label-for": "description",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "email content",
                              vid: "Description",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("quill-editor", {
                                        attrs: {
                                          state:
                                            errors.length > 0 ? false : null,
                                        },
                                        model: {
                                          value: _vm.campaignId.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.campaignId,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "campaignId.description",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1354877886
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.facebookChecked ||
              _vm.instagramChecked ||
              _vm.linkedinChecked ||
              _vm.EventChecked === false
                ? _c("b-col", { attrs: { md: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "demo-inline-spacing" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.drafting("draft")
                              },
                            },
                          },
                          [_vm._v(" Save as Draft ")]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.publish("sendNow")
                              },
                            },
                          },
                          [_vm._v(" Send Now ")]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.schedule("schedule")
                              },
                            },
                          },
                          [_vm._v(" Schedule Post ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modalAddTasks",
          attrs: {
            id: "modal-add-tasks",
            title: "Add New Task",
            "hide-footer": "",
            centered: "",
          },
          on: { hide: _vm.resetForm },
        },
        [
          _c("validation-observer", {
            ref: "addTaskForm",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var invalid = ref.invalid
                  var validate = ref.validate
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            validate().then(function (success) {
                              return success && _vm.addTasks()
                            })
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Task", "label-for": "task" } },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Task", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: { id: "task" },
                                          model: {
                                            value: _vm.newtasks.task,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newtasks,
                                                "task",
                                                $$v
                                              )
                                            },
                                            expression: "newtasks.task",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Assignee",
                              "label-for": "assignee",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Assignee", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "assignee",
                                            options: _vm.employeeList,
                                            "value-field": "id",
                                            "text-field": "firstName",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.newtasks.assignee,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newtasks,
                                                "assignee",
                                                $$v
                                              )
                                            },
                                            expression: "newtasks.assignee",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          { attrs: { label: "Budget", "label-for": "budget" } },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Budget", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: { id: "budget" },
                                          model: {
                                            value: _vm.newtasks.budget,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newtasks,
                                                "budget",
                                                $$v
                                              )
                                            },
                                            expression: "newtasks.budget",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          { attrs: { label: "Status", "label-for": "status" } },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Status", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "status",
                                            options: _vm.statusOptions,
                                          },
                                          model: {
                                            value: _vm.newtasks.status,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newtasks,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "newtasks.status",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "StartDate",
                              "label-for": "startDate",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "StartDate", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          staticClass: "mb-1",
                                          attrs: {
                                            id: "example-datepicker",
                                            min: _vm.today,
                                            "date-format": "yyyy-MM-dd",
                                          },
                                          model: {
                                            value: _vm.newtasks.startDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newtasks,
                                                "startDate",
                                                $$v
                                              )
                                            },
                                            expression: "newtasks.startDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "EndDate", "label-for": "endDate" },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "EndDate", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          staticClass: "mb-1",
                                          attrs: {
                                            id: "example-datepicker1",
                                            min: _vm.today,
                                            "date-format": "yyyy-MM-dd",
                                          },
                                          model: {
                                            value: _vm.newtasks.endDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newtasks,
                                                "endDate",
                                                $$v
                                              )
                                            },
                                            expression: "newtasks.endDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: invalid,
                            },
                          },
                          [_vm._v(" Add Tasks ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }